import React, { useRef, useState } from 'react';
import { CAREERS_ASSETS } from './careersAssets';

const TABS = [
  { key: 'prepared', n: '01', label: 'Prepared', eyebrow: 'PREPARED', title: ['Ready before', 'you begin.'], alt: 'Gloved hands preparing cleaning tools',
    body: 'Understand the assignment. Bring the supplies and equipment you need. Arrive ready to give the space your attention.' },
  { key: 'systematic', n: '02', label: 'Systematic', eyebrow: 'SYSTEMATIC', title: ['A process', 'with purpose.'], alt: 'Cleaner vacuuming an office floor',
    body: 'Follow a clear order, work through the space, and communicate when something needs clarification.' },
  { key: 'detail', n: '03', label: 'Detail-Driven', eyebrow: 'DETAIL-DRIVEN', title: ['Notice what', 'others miss.'], alt: 'Cleaner attending to details on a tabletop',
    body: 'Give the edges, corners, and finishing touches the same care as the surfaces everyone sees.' },
  { key: 'verified', n: '04', label: 'Verified', eyebrow: 'VERIFIED', title: ['Check the work.', 'Own the result.'], alt: 'Reviewing a checklist',
    body: 'Take a final look against the assignment. Check what you completed and communicate anything that still needs attention.' },
];

const EXPECTATIONS = [
  ['Dependability', 'Show up when agreed and communicate changes early.'],
  ['Respect', 'Treat clients, their spaces, and the team with care.'],
  ['Willingness to learn', 'Ask questions, use feedback, and learn the Guru process.'],
];

export const GuruWorld = () => {
  const [active, setActive] = useState(0);
  const tabRefs = useRef([]);

  const onKeyDown = (e, i) => {
    const map = { ArrowRight: (i + 1) % TABS.length, ArrowLeft: (i + TABS.length - 1) % TABS.length, Home: 0, End: TABS.length - 1 };
    const j = map[e.key];
    if (j === undefined) return;
    e.preventDefault();
    setActive(j);
    tabRefs.current[j]?.focus();
  };

  return (
    <section className="guru-world" id="guru-standard" aria-labelledby="world-title" data-testid="guru-world-section">
      <div className="world-opening">
        <div className="world-opening-copy">
          <p className="section-label">THE GURU STANDARD</p>
          <h2 id="world-title">Pride in the work. <br /><span>Care in the details.</span></h2>
          <p>Every home and workspace belongs to someone. Becoming a Guru means showing up prepared, respecting the space, and taking care with the work you leave behind.</p>
          <a href="#world-principles" className="world-explore" data-testid="world-explore">EXPLORE THE STANDARD <span>↓</span></a>
        </div>
        <div className="world-photo">
          <img src={CAREERS_ASSETS.standardCleaner} alt="Cleaner in an orange Gleam Guru shirt wiping a glass surface" loading="lazy" />
          <span className="world-photo-label">THE PEOPLE BEHIND THE CLEAN</span>
        </div>
      </div>
      <div className="world-principles" id="world-principles">
        <div className="world-tabs" role="tablist" aria-label="Guru Standard principles">
          {TABS.map((t, i) => (
            <button
              key={t.key}
              ref={(el) => { tabRefs.current[i] = el; }}
              role="tab"
              type="button"
              id={`tab-${t.key}`}
              aria-selected={active === i ? 'true' : 'false'}
              aria-controls={`world-${t.key}`}
              tabIndex={active === i ? 0 : -1}
              onClick={() => setActive(i)}
              onKeyDown={(e) => onKeyDown(e, i)}
              data-testid={`world-tab-${t.key}`}
            >
              <small>{t.n}</small><b>{t.label}</b><span>↗</span>
            </button>
          ))}
        </div>
        {TABS.map((t, i) => (
          <div key={t.key} className="world-panel" role="tabpanel" id={`world-${t.key}`} aria-labelledby={`tab-${t.key}`} hidden={active !== i} data-testid={`world-panel-${t.key}`}>
            <img src={CAREERS_ASSETS.posters[t.key]} alt={t.alt} loading="lazy" />
            <div>
              <p className="section-label">{t.eyebrow}</p>
              <h3>{t.title[0]}<br />{t.title[1]}</h3>
              <p>{t.body}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="world-guru-card">
        <div className="world-guru-art">
          <img src={CAREERS_ASSETS.clipboardGuru} alt="Official Guru holding the Guru Standard clipboard" loading="lazy" />
        </div>
        <div className="world-expectations">
          <p className="section-label">WHAT WE EXPECT</p>
          <h3>Bring your care. <br />Build your craft.</h3>
          <p>You don’t need experience to apply for the W-2 path. You do need a willingness to learn, communicate, and take pride in your work.</p>
          <ul>
            {EXPECTATIONS.map(([b, s]) => <li key={b}><b>{b}</b><span>{s}</span></li>)}
          </ul>
        </div>
      </div>
    </section>
  );
};
